import { useLanguage } from '@/contexts/LanguageContext';

/**
 * YouTube embed with auto-translate subtitles support.
 * - Autoplay + muted (browser policy)
 * - Captions auto-loaded in user's language
 * - If user's language unavailable, English captions shown with auto-translate available via CC menu
 */
export default function YouTubeAutoTranslate({ videoId, title }) {
  const { currentLang } = useLanguage();

  if (!videoId) return null;

  // Build YouTube embed URL with smart subtitle params
  const params = new URLSearchParams({
    autoplay: '1',
    mute: '1',
    rel: '0',
    modestbranding: '1',
    cc_load_policy: '1',        // Force captions ON
    cc_lang_pref: currentLang,  // Prefer user's language subtitle
    hl: currentLang,            // YouTube UI in user's language
    iv_load_policy: '3',        // Hide annotations
  });

  return (
    <div className="rounded-2xl overflow-hidden border border-amber-500/20 shadow-[0_0_30px_rgba(245,158,11,0.08)]" data-testid="city-video">
      <div className="aspect-video">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?${params.toString()}`}
          title={title || 'Video'}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
